import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';
import type { AnalyticAttributes } from '@gonfalon/docs/analytics';

export const trackCampaign = createTrackerForCategory('CampaignTrial');

export const trackEnterpriseCampaignCtaClicked = (upsellPage: string, analyticAttributes: AnalyticAttributes) =>
  trackCampaign('Try Enterprise CTA Clicked', { ...analyticAttributes, upsellPage });

export const trackEnterpriseCampaignCancelClicked = (analyticAttributes: AnalyticAttributes) =>
  trackCampaign('Start Enterprise Campaign Cancel Clicked', analyticAttributes);

export const trackEnterpriseCampaignConfirmClicked = (analyticAttributes: AnalyticAttributes) =>
  trackCampaign('Start Enterprise Campaign Confirm Clicked', analyticAttributes);
